import React from 'react';

import { noop } from 'lodash';

const defaultValue = {
  isOffline: false,
  setIsOffline: noop,
};

const OfflineStateContext = React.createContext(defaultValue);
const { Provider, Consumer } = OfflineStateContext;

export { OfflineStateContext, Provider, Consumer };
